import { Component, OnInit } from '@angular/core';
import { I18nService } from 'core-app/modules/common/i18n/i18n.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
declare let layui:any

// 定义上传响应接口
interface ExcelUploadResponse {
  success: boolean;
  message?: string;
  data?: any;
}

// 定义错误响应接口
interface ErrorResponse {
  error?: string;
  message?: string;
  errors?: any;
}

@Component({
  templateUrl: './contract-management-excel.component.html',
  styleUrls: ['./contract-management-excel.component.sass']
})
export class ContractManagementExcelComponent implements OnInit {

  public excelData: any[];
  public projectId: string;
  public isUploading: boolean = false;
  public tableData: any[] = [];
  public page:any=1
  public per_page:any=10
  public total:any=0
  public isInit:any=true
  public isUpload:any=false //是否有权限上传
  constructor(
    readonly http: HttpClient,
    public i18n: I18nService
  ) { }

  ngOnInit() {
    const currentProject: any = document.querySelector('meta[name=current_project]');
    if (currentProject && currentProject.dataset && currentProject.dataset.projectId) {
      this.projectId = currentProject.dataset.projectId;
    } else {
      console.error('无法获取项目 ID');
    }
    this.getData()
    // this.excelData = [
    //   { name: 'Contract A', created_at: '2023-01-15', operator: 'John Doe' },
    //   { name: 'Contract B', created_at: '2023-02-20', operator: 'Jane Smith' },
    //   { name: 'Contract C', created_at: '2023-03-10', operator: 'Peter Jones' }
    // ];
  }
  initPage(){
    let self = this
    layui.use('laypage', function(){
        var laypage = layui.laypage;
        //执行一个laypage实例
        laypage.render({
          elem: 'page' //注意，这里的 test1 是 ID，不用加 # 号
          ,count: Number(self.total),
          jump: (obj:any,first:any) => {
            console.log(first,'first');
            console.log(obj)
            self.page = obj.curr
            if(!first){
              self.getData()
            }
          }//数据总数，从服务端得到
        });
      });
  }
  getData (){
       const params = new URLSearchParams({
        page: this.page,
        per_page:this.per_page
    });
    fetch(`${window.location.origin}/api/v3/projects/${this.projectId}/excel`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }})
          .then(response => response.json())
          .then(data => {
            this.tableData = []
            this.tableData = data.data
            console.log(data,'data', this.tableData);
            this.total = data.pagination.total_entries
            this.isUpload = data.create_power
            if(this.isInit){
                this.initPage()
                this.isInit = false
            }
          })
          .catch(error => {
            console.error('Error fetching data:', error)
          });
  }
  upload() {
    // 检查 projectId 是否可用
    if (!this.projectId) {
      alert('错误：无法获取项目 ID，请刷新页面重试');
      return;
    }

    // 创建文件输入元素
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.xlsx,.xls';
    fileInput.style.display = 'none';

    fileInput.onchange = (event: any) => {
      const file = event.target.files[0];
      if (file) {
        this.uploadFile(file);
      }
    };

    document.body.appendChild(fileInput);
    fileInput.click();
    document.body.removeChild(fileInput);
  }

  private uploadFile(file: File) {
    // 验证文件类型
    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
      'application/excel'
    ];
    
    if (!allowedTypes.includes(file.type) && !file.name.toLowerCase().endsWith('.xlsx') && !file.name.toLowerCase().endsWith('.xls')) {
      alert('错误：请选择有效的 Excel 文件（.xlsx 或 .xls）');
      return;
    }

    // 验证文件大小（限制为 10MB）
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      alert('错误：文件大小不能超过 10MB');
      return;
    }

    // 准备上传
    this.isUploading = true;
    
    // 创建 FormData
    const formData = new FormData();
    formData.append('file', file);
    
    // 添加元数据（根据 API 要求）
    const metadata = [
      { index: 1, name: 'Sheet1' }
    ];
    formData.append('metadata', JSON.stringify(metadata));

    // 设置请求头
    const headers = new HttpHeaders({
      'X-Authentication-Scheme': 'Session',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': (document.querySelector('meta[name=csrf-token]') as HTMLMetaElement).content || ''
    });

    // 构建动态 URL
    const uploadUrl = `api/v3/projects/${this.projectId}/excel`;
    jQuery('.isload').css('display', 'block')
    // 发送请求
    this.http.post<ExcelUploadResponse>(uploadUrl, formData, { 
      headers,
      withCredentials: true 
    })
    .pipe(
      catchError((error: HttpErrorResponse) => {
        this.handleUploadError(error);
        return throwError(error);
      })
    )
    .subscribe({
      next: (response: ExcelUploadResponse) => {
        this.handleUploadSuccess(response);
      },
      error: (error) => {
        // 错误已在 catchError 中处理
        console.error('上传失败:', error);
      },
      complete: () => {
        this.isUploading = false;
        jQuery('.isload').css('display', 'none')
      }
    });
  }

  private handleUploadSuccess(response: ExcelUploadResponse) {
    this.isUploading = false;
    
    if (response && response.success) {
      alert('Excel 文件上传成功！');
      // 可以在这里刷新数据或执行其他成功后的操作
      this.refreshData();
    } else {
      const message = response.message || '上传失败，请重试';
      alert(`上传失败：${message}`);
    }
  }

  private handleUploadError(error: HttpErrorResponse) {
    this.isUploading = false;
    
    let errorMessage = '上传失败，请重试';
    
    if (error.status === 0) {
      errorMessage = '网络连接失败，请检查网络连接';
    } else if (error.status === 400) {
      errorMessage = '请求参数错误，请检查文件格式';
    } else if (error.status === 401) {
      errorMessage = '身份验证失败，请重新登录';
    } else if (error.status === 403) {
      errorMessage = '没有权限执行此操作';
    } else if (error.status === 404) {
      errorMessage = '上传接口不存在，请联系管理员';
    } else if (error.status === 413) {
      errorMessage = '文件过大，请选择较小的文件';
    } else if (error.status === 422) {
      errorMessage = '文件格式不正确或数据验证失败';
    } else if (error.status >= 500) {
      errorMessage = '服务器内部错误，请稍后重试';
    } else if (error.error) {
      // 尝试从错误响应中提取具体错误信息
      const errorResponse = error.error as ErrorResponse;
      if (errorResponse.message) {
        errorMessage = errorResponse.message;
      } else if (errorResponse.error) {
        errorMessage = errorResponse.error;
      } else if (errorResponse.errors) {
        errorMessage = JSON.stringify(errorResponse.errors);
      }
    }
    
    alert(`上传失败：${errorMessage}`);
    console.error('上传错误详情:', error);
  }

  private refreshData() {
    // 刷新页面数据的逻辑
    // 可以调用 API 获取最新的 Excel 文件列表
    this.getData()
    console.log('刷新数据...');
  }

  delete(item: any) {
    // 在这里处理删除逻辑
    alert('Delete button clicked for item: ' + item.name);
  }

}